var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['xm-step-icon', _vm.statusClass],style:({
    width: _vm.diameter,
    height: _vm.diameter,
    lineHeight: _vm.diameter,
  })},[(_vm.status != 'finish')?_c('span',[_vm._v(_vm._s(_vm.num))]):_c('img',{attrs:{"width":_vm.diameter,"height":_vm.diameter,"src":require("@/assets/images/stepfirst.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }